// Initialize Accordions
const accordions = document.querySelectorAll('.accordion');

if (accordions.length > 0) {    
    accordions.forEach((accordion) => {
        let accordionButtons = accordion.querySelectorAll('button.accordion__item__header');
        
        accordionButtons.forEach((item) => {
            // active class for accordion header
            item.addEventListener('click', () => {
                let accordionPanel = item.nextElementSibling;
                item.classList.toggle('active');
                
                // open accordion panel
                accordionPanel.classList.toggle('open');
                accordionPanel.style.height = `${accordionPanel.scrollHeight}px`;

                if( ! item.classList.contains('active') ) {
                    accordionPanel.style.height = '';
                }
            });
        });
        
    });
}